import Vue from 'vue';
import getApiErrorMessage from '@/helpers/getApiErrorMessage';

const RHandler = {};

export const rHandler = (
  promise,
  onSuccess = () => {},
  onReject = () => {},
  validationObserver,
) =>
  promise
    .then((response) => {
      if (!response) return onReject();

      if (response.data.result_code !== 'FLSCS') {
        const rejectResponse = onReject(response);
        if (rejectResponse === undefined) {
          const message = response.data.data?.message || response.data?.result_message;
          Vue.$toast.error(message, { timeout: 5000 });
        }
        return rejectResponse;
      }
      return onSuccess(response);
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error);
      Vue.$toast.error(getApiErrorMessage(error));

      if (error.response?.data?.result_code === 'VAL01') {
        const errors = error.response.data.validation;
        if (validationObserver) validationObserver.setErrors(errors);
      }

      return onReject(error);
    });

RHandler.install = (V) => {
  V.rHandler = rHandler;
  V.prototype.$rHandler = rHandler;
};

export default RHandler;
